import { FC } from 'react';
import styles from './styles.module.less';
import TermsOfUseForm from './TermsOfUseForm';
// import { StaticInfoSelection } from './StaticInfoSelection';
import Container from 'components/StaticPageContainer';

const TermsOfUsePage: FC = () => {
  return (
    <div className={styles.root}>
      {/* <StaticInfoSelection /> */}
      <Container size="md">
        <TermsOfUseForm />
      </Container>
    </div>
  );
};

export default TermsOfUsePage;
